import { Draft, produce } from 'immer';
import { getDiscountsSupportedKey } from './getters/getDiscountsSupportedKey';
import { DiscountState, DiscountsActionTypes, DiscountsActions } from './types';

const INITIAL_STATE: DiscountState = {
  quantity: {},
  productType: {},
  supported: {},
};

export const discountsReducer = produce((draft: Draft<DiscountState>, action: DiscountsActions) => {
  switch (action.type) {
    case DiscountsActionTypes.DISCOUNTS_SET_PRODUCT_TYPE:
      draft.productType[action.productTypeId] = [...action.discounts].sort(
        (a, b) => a.valueRange.from - b.valueRange.from
      );
      return draft;
    case DiscountsActionTypes.DISCOUNTS_SET_QUANTITY:
      draft.quantity[action.quantity] = action.discounts;
      return draft;
    case DiscountsActionTypes.DISCOUNTS_SUPPORTED:
      action.payload.forEach(({ contextId, productTypeId, supported }) => {
        draft.supported[getDiscountsSupportedKey(contextId, productTypeId)] = supported;
      });
      return draft;
    default:
      return draft;
  }
}, INITIAL_STATE);
